var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInappropriatecontent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_3558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.556 22H6.44402L0 15.556V6.44402L6.44398 0H15.556L22 6.44398V15.556L15.556 22Z",
    fill: "#E76E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 11.6875H8.9375L8.25 3.4375H13.75L13.0625 11.6875ZM8.9375 14.4375H13.0625V18.5625H8.9375V14.4375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_3558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInappropriatecontent);
export default __webpack_public_path__ + "static/media/inappropriatecontent.2550d8677d0e2fee5f30470246c0ee46.svg";
export { ForwardRef as ReactComponent };